import type { IShape } from '../../rendering/IRenderer';
import { delay } from '../../../shared/utils/Timer';

/** A deadline owns the spawned shape generation, never a later pooled reuse. */
export function scheduleEffectExpiry(
  shapes: readonly IShape[],
  durationMs: number,
  expire: (shape: IShape) => void,
): void {
  const generation = (shape: IShape) => (shape as IShape & { generation?: number }).generation ?? 0;
  const generations = shapes.map(generation);
  delay(durationMs, () => {
    shapes.forEach((shape, index) => {
      if (shape?.active && generation(shape) === generations[index]) expire(shape);
    });
  });
}
